// Document ready
(function($) {
  "use strict";
  
$(document).ready(function() {
  // Function to update the variant title
  function updateVariantTitle() {
    // Get the selected variant's title
    var selectedVariantTitle = $('.option-selector option:selected').text();

    // Update the variant title element
    $('#variant-title').text( selectedVariantTitle + ' ');
  }

  // Attach change event listener to the variant selector
  $('.option-selector').on('change', function() {
    updateVariantTitle();
  });

  // Initial call to set the title correctly on page load
  updateVariantTitle();
  });

})(jQuery);